import {
  AbhaCustomIcon,
  ArrowLeftRegularIcon,
  CirclePlaySolidIcon,
  EarnIncentives,
  EkaIcon,
  GetCertifcateToRecognition,
  Nha,
} from "@elixir/icons";
import { PrimaryButton, SecondaryButton } from "ui";
import useGetMyProfile from "../apis/axon/get-my-profile";
import HfrCreatedSuccessfully from "../organisms/hpr-hfr-onboarding/hfr-created-successfully";
import HfrForm from "../organisms/hpr-hfr-onboarding/hfr-form";
import HprCreatedSuccessfully from "../organisms/hpr-hfr-onboarding/hpr-created-successfully";
import OnboardingFlowSteps from "../organisms/hpr-hfr-onboarding/onboarding-flow-steps";
import SetupYourHprId from "../organisms/hpr-hfr-onboarding/setup-your-hpr-id";
import VerifyPhoneNumber from "../organisms/hpr-hfr-onboarding/verify-phone-number";
import VerifyYourselfWithAadhaar from "../organisms/hpr-hfr-onboarding/verify-yourself-with-aadhaar";
import VerifyAadhaarOtp from "../organisms/hpr-hfr-onboarding/verify-yourself-with-aadhaar/verify-aadhaar-otp";
import { CustomButtonComponent } from "../organisms/queue/queue-header";
import useHprHfrOnboardingStore from "../stores/hpr-hfr-dhis-onboarding";
import { OnboardingNavigationStates } from "../stores/hpr-hfr-dhis-onboarding/enums";
import ExistingHfrModal from "./existing-hfr-modal";

const ActiveScreen = () => {
  const activeScreen = useHprHfrOnboardingStore((state) => state.activeScreen);
  const { data: _ } = useGetMyProfile();

  switch (activeScreen) {
    case OnboardingNavigationStates.AADHAR:
      return <VerifyYourselfWithAadhaar />;
    case OnboardingNavigationStates.AADHAR_OTP:
      return <VerifyAadhaarOtp />;
    case OnboardingNavigationStates.PHONE_NUMBER:
      return <VerifyPhoneNumber />;
    case OnboardingNavigationStates.SETUP_HPR_ID:
      return <SetupYourHprId />;
    case OnboardingNavigationStates.HPR_ID_SUCCESSFUL:
      return <HprCreatedSuccessfully />;
    case OnboardingNavigationStates.HFR_FORM:
      return <HfrForm />;
    case OnboardingNavigationStates.HFR_CREATION_COMPLETED:
      return <HfrCreatedSuccessfully />;
    default:
      return <div>Missing Screen</div>;
  }
};

const VerifyFlow = () => {
  return (
    <div className="dr-h-full dr-w-full dr-grid dr-grid-rows-6">
      <div className="dr-row-start-1 dr-row-end-7 md:dr-row-end-6 dr-grid dr-grid-cols-12 md:dr-divide-x-2 md:dr-divide-darwin-touch-neutral-100 dr-flex-1">
        <div className="dr-hidden md:dr-block dr-col-start-1 dr-col-end-4">
          <OnboardingFlowSteps />
        </div>
        <div className="dr-col-start-1 md:dr-col-start-4 dr-col-end-13">
          <ActiveScreen />
        </div>
      </div>
      <div className="dr-hidden md:dr-row-start-6 md:dr-row-end-7 md:dr-flex dr-items-center dr-border-t-2 dr-border-darwin-touch-neutral-100">
        <Footer />
      </div>
    </div>
  );
};

const Footer = () => {
  return (
    <div className="dr-w-full dr-py-16 dr-px-48 dr-flex dr-items-center dr-justify-between">
      <div className="dr-flex dr-items-center dr-space-x-12">
        <EkaIcon className="dr-w-40 dr-h-40" />
        <AbhaCustomIcon className="dr-w-40 dr-h-40" />
        <img
          className="dr-h-58 dr-w-58"
          src="https://cdn.eka.care/vagus/clqpc0dxn002v0tdfenjn1g1c.webp"
          alt="ayushman-bharat"
        />
      </div>
      {/* <div className="CalloutRegular dr-text-darwin-touch-neutral-800">
        <span>Have some queries? call us at </span>
        <span className="CalloutBold dr-text-darwin-touch-primary-primary">
          <a href="tel:1800111663">1800 111 663</a>
        </span>
      </div> */}
      <div className="dr-flex dr-items-center dr-space-x-24">
        <div className="Caption2SemiBold dr-text-darwin-touch-neutral-800">
          Approved by
        </div>
        <Nha className="dr-w-68" />
      </div>
    </div>
  );
};

const HprHfrOnboarding = () => {
  const activeScreen = useHprHfrOnboardingStore((state) => state.activeScreen);
  const setActiveScreen = useHprHfrOnboardingStore(
    (state) => state.setActiveScreen
  );

  if (activeScreen === OnboardingNavigationStates.LANDING) {
    return (
      <div className="dr-grid dr-grid-cols-12 dr-gap-x-24 dr-w-screen dr-h-full dr-overflow-y-scroll">
        <div className="dr-col-span-full dr-flex dr-items-center dr-justify-between dr-px-16 dr-py-12 dr-h-60 dr-border-b-1 dr-border-darwin-touch-neutral-200 dr-z-1 dr-sticky dr-top-0 dr-bg-darwin-touch-neutral-0">
          <div className="Title3Regular dr-text-darwin-touch-neutral-1000">
            ABHA Dashboard
          </div>
          <CustomButtonComponent />
        </div>
        <div
          className="dr-col-start-3 dr-col-end-11 dr-space-y-32 dr-flex dr-flex-col dr-pt-44"
          style={{ height: `calc(100%% - 3.8125rem)` }}
        >
          <div className="dr-space-y-4 dr-flex dr-flex-col dr-items-center dr-text-center">
            <div className="Title1Bold">
              <span className="dr-text-darwin-touch-neutral-1000">
                Earn with eka :{" "}
              </span>
              <span className="dr-text-darwin-touch-green-primary">
                {" "}
                An ABDM initiative
              </span>
            </div>
            <div className="HeadingsH2Regular dr-text-darwin-touch-neutral-600">
              Enroll into DHIS and start receiving incentives for every medical
              record linked
            </div>
          </div>
          <div className="dr-space-y-16">
            <div className="dr-flex dr-items-center dr-space-x-16">
              <BrightCard
                icon={<EarnIncentives />}
                className="dr-bg-darwin-touch-green-bg-light"
                title="Earn incentives"
                subtitle="Earn upwards of ₹9,23,920 with DHIS scheme for ABDM initiative of Govt. of India. "
              />
              <BrightCard
                className="dr-bg-darwin-touch-yellow-bg-light"
                icon={<GetCertifcateToRecognition />}
                title="Get certificate of recognition"
                subtitle="For your effort towards the national cause of digitising healthcare in India. "
              />
            </div>
            <div className="dr-space-y-8 dr-flex dr-flex-col dr-items-center">
              <div className="Title3Bold dr-text-darwin-touch-neutral-1000">
                Eka success stories
              </div>
              <div className="dr-flex dr-items-center dr-space-x-16">
                <StoriesCard
                  name="Dr. Nishant Mittal"
                  area="BHopal"
                  about="Earnings from Eka’s DHIS program"
                  earning={1}
                />
                <StoriesCard
                  name="Dr. Nishant Mittal"
                  area="BHopal"
                  about="Earnings from Eka’s DHIS program"
                  earning={1}
                />
                <StoriesCard
                  name="Dr. Nishant Mittal"
                  area="BHopal"
                  about="Earnings from Eka’s DHIS program"
                  earning={1}
                />
              </div>
            </div>
          </div>
          <div className="dr-flex dr-flex-col dr-w-full dr-items-center dr-space-y-16">
            <div className="dr-flex dr-items-center dr-space-x-12">
              <SecondaryButton
                extraClass="dr-w-200"
                title="Know more about ABDM"
                IconComponent={() => (
                  <CirclePlaySolidIcon className="dr-text-darwin-touch-primary-primary" />
                )}
                onClick={() => {
                  window.open(
                    "https://www.eka.care/ayushman-bharat?utm_source=%2Fayushman-bharat&utm_medium=eka-web&utm_campaign=web-navigation",
                    "_blank"
                  );
                }}
              />
              <PrimaryButton
                extraClass="dr-w-200"
                title="Go to Aadhar"
                IconComponent={() => (
                  <ArrowLeftRegularIcon className="dr-rotate-180" />
                )}
                onClick={() => {
                  setActiveScreen(OnboardingNavigationStates.AADHAR);
                }}
              />
            </div>
            <div className="dr-text-center">
              <span className="CalloutRegular dr-text-darwin-touch-neutral-800">
                To know more, call us at{" "}
              </span>
              <span className="dr-text-darwin-touch-primary-primary CalloutBold ">
                <a href="tel:1800111663">1800 111 663</a>
              </span>
            </div>
          </div>
        </div>
        <MainPageFooter />
      </div>
    );
  }
  return (
    <>
      <VerifyFlow />
      <ExistingHfrModal />
    </>
  );
};

export default HprHfrOnboarding;

const MainPageFooter = () => {
  return (
    <div className="dr-space-y-8 dr-col-span-full dr-p-16 dr-flex dr-flex-col dr-items-end dr-justify-end">
      <div className="dr-flex dr-items-center dr-space-x-12">
        <Nha className="dr-w-68" />
        <AbhaCustomIcon className="dr-w-39 dr-h-38" />
        <img
          className="dr-h-52"
          src="https://cdn.eka.care/vagus/clqpc0dxn002v0tdfenjn1g1c.webp"
          alt="ayushman-bharat"
        />
      </div>
      <div className="CalloutBold dr-text-right dr-cursor-pointer dr-text-darwin-touch-primary-primary">
        View Eka ABDM Certificate
      </div>
    </div>
  );
};

const StoriesCard = ({
  name,
  earning,
  area,
  about,
}: {
  name: string;
  earning: number;
  area: string;
  about: string;
}) => {
  return (
    <div className="dr-p-16 dr-border-1 dr-border-darwin-touch-primary-bg-light dr-rounded-12 dr-space-y-12">
      <div className="dr-space-x-8 dr-flex dr-items-center">
        <div className="dr-w-36 dr-min-w-36 dr-h-36 dr-rounded-full dr-bg-yellow"></div>
        <div>
          <div className="SubheadlineBold dr-text-darwin-touch-primary-dark">
            {name}
          </div>
          <div className="Caption1Medium dr-text-darwin-touch-neutral-400">
            {area}
          </div>
        </div>
      </div>
      <div className="dr-space-y-4">
        <div className="LabelMedium dr-text-darwin-touch-neutral-600">
          {about}
        </div>
        <div className="dr-text-darwin-touch-neutral-1000">
          <span className="HeadlineExtraBold">₹{earning} </span>
          <span className="BodyBody1Regular">lac/month</span>
        </div>
      </div>
    </div>
  );
};

const BrightCard = ({
  icon,
  title,
  subtitle,
  className = "",
}: {
  className?: string;
  title: string;
  subtitle: string;
  icon: JSX.Element;
}) => {
  return (
    <div className={`dr-p-16 dr-space-x-16 dr-rounded-12 dr-flex ${className}`}>
      <div className="dr-self-start">{icon}</div>
      <div className="dr-space-y-2">
        <div className="SubheadlineBold dr-text-darwin-touch-neutral-1000">
          {title}
        </div>
        <div className="BodyRegular dr-text-darwin-touch-neutral-600">
          {subtitle}
        </div>
      </div>
    </div>
  );
};
